<template>
  <div>
    <v-progress-linear
      :active="isLoading"
      :indeterminate="isLoading"
      absolute
      top
      color="#743063"
    ></v-progress-linear>
    <br />

    <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
    <br />
    <div v-if="!isLoading" class="ma-2">
      <h4 class="text-center">{{ subscriptionDetail.name | localized }}</h4>
      <v-card max-width="400" class="mx-auto my-2">
        <v-app-bar color="white" flat>
          <v-toolbar-title>
            {{ subscriptionDetail.name | localized }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            v-if="subscriptionDetail.status != 'Canceled'"
            dense
            outlined
            color="red"
            class="ma-2 white--text"
            @click="cancelDialog = true"
          >
            إلغاء
            <v-icon right dark> mdi-cancel </v-icon>
          </v-btn>
          <v-btn
            v-if="subscriptionDetail.status != 'Active'"
            dense
            outlined
            color="green"
            class="ma-2 white--text"
            @click="activateSubscription"
          >
            تفعيل
            <v-icon right dark> mdi-check </v-icon>
          </v-btn>
        </v-app-bar>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>الرصيد</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text
              >KD {{ subscriptionDetail.balance }}</v-list-item-action-text
            ></v-list-item-action
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>عدد الكفالات</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text
              >KD {{ subscriptionDetail.numberOfShares }}</v-list-item-action-text
            ></v-list-item-action
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>حالة الاشتراك</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon v-if="subscriptionDetail.status == 'Active'" color="green"
              >mdi-check-circle-outline</v-icon
            >
            <v-icon v-else color="red">mdi-alpha-x-circle-outline</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>موعد القسط التالي</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              {{ nextBillingDate() }}</v-list-item-action-text
            ></v-list-item-action
          >
        </v-list-item>
        <v-card-text>
          <h4>الأقساط</h4>

          <v-list>
            <v-list-item
              v-for="installment in subscriptionDetail.installments"
              :key="installment.id"
            >
              <v-list-item-content>
                <v-list-item-title
                  >{{ installment.amount }} KD</v-list-item-title
                >
                <v-list-item-subtitle
                  >تاريخ الاستحقاق:
                  {{
                    toDateString(installment.installmentDate)
                  }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >تاريخ الدفع:
                  {{ toDateString(installment.paidDate) }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <div v-if="isPreparingForPayment">
                <v-icon v-if="installment.isPaid" color="green"
                  >mdi-check-circle-outline</v-icon
                >
                <v-checkbox
                  v-else
                  v-model="unpaidInstallments[installment.id]"
                ></v-checkbox>
              </div>
              <div v-else>
                <v-icon v-if="installment.isPaid" color="green"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else color="orange">mdi-information-outline</v-icon>
              </div>
            </v-list-item>
            <v-divider inset></v-divider>
          </v-list>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            v-if="isPreparingForPayment == false"
            rounded
            dark
            class="ma-1"
            color="#019891"
            @click="isPreparingForPayment = true"
          >
            دفع الأقساط
          </v-btn>

          <v-btn
            v-if="isPreparingForPayment"
            rounded
            dark
            class="ma-1"
            color="#019891"
            @click="isPreparingForPayment = false"
          >
            إلغاء
          </v-btn>
          <v-btn
            v-if="isPreparingForPayment == false"
            dark
            class="ma-1"
            rounded
            @click="addMultipleInstallmentsDialog = true"
          >
            اضافة عدة أقساط جديدة</v-btn
          >
          <v-btn
            :disabled="subscriptionInstallmentIds.length == 0"
            v-if="isPreparingForPayment"
            :loading="isPaying"
            rounded
            :dark="subscriptionInstallmentIds.length != 0"
            class="ma-1"
            color="#743063"
            @click="completePaymentProcess"
          >
            اتمام الدفع
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="addMultipleInstallmentsDialog" width="300">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            اضافة عدة أقساط
          </v-card-title>

          <v-card-text>
            <div class="d-flex mx-auto my-3 align-center">
              <v-btn
                class="ma-1"
                :disabled="quantity < 2"
                icon
                color="black"
                @click="quantity -= 1"
                ><v-icon>mdi-minus</v-icon></v-btn
              >
              <v-chip class="ma-1">{{ quantity }}</v-chip>
              <v-btn class="ma-1" icon color="black" @click="quantity += 1"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              :loading="isAdding"
              rounded
              dark
              class="ma-1"
              color="#019891"
              @click="addMultipleInstallments"
            >
              تأكيد الاضافة
            </v-btn>

            <v-btn
              rounded
              dark
              class="ma-1"
              color="#743063"
              @click="
                addMultipleInstallmentsDialog = false;
                quantity = 1;
              "
            >
              إلغاء
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="cancelDialog" width="300">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            إلغاء الاشتراك
          </v-card-title>

          <v-card-text>
           إلغاء الاشتراك سيلغي الأقساط المستحقة وستبقى الأقساط المدفوعة سابقاً، هل أنت متأكد من إلغاء الاشتراك؟
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              :loading="isCanceling"
              rounded
              dark
              class="ma-1"
              color="#019891"
              @click="cancelSubscription"
            >
              نعم
            </v-btn>

            <v-btn
              :disabled="isCanceling"
              rounded
              dark
              class="ma-1"
              color="#743063"
              @click="cancelDialog = false"
            >
              لا
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}
export default {
  name: "SubscriptionDetail",
  props: {
    id: {
      type: Number,
      default: -1,
    },
  },
  components: {},
  //********************** */
  data: () => ({
    cancelDialog: false,
    activating: false,
    quantity: 1,
    isAdding: false,
    isCanceling: false,
    addMultipleInstallmentsDialog: false,
    isLoading: false,
    isPaying: false,
    isPreparingForPayment: false,
    unpaidInstallments: {},
    breadcrumbItems: [
      {
        text: "الاشتراكات",
        disabled: false,
        to: "/MySubscriptions",
      },
    ],
  }),

  watch: {
    $route: "loadSubscriptionDetail",
  },

  //********************** */
  computed: {
    ...mapGetters("Subscription", {
      subscriptionDetail: "subscriptionDetail",
      externalPaymentUrl: "externalPaymentUrl",
    }),

    subscriptionInstallmentIds: function () {
      let dict = this.unpaidInstallments;
      var filtered = Object.keys(dict).reduce(function (filtered, key) {
        if (dict[key] == true) filtered[key] = dict[key];
        return filtered;
      }, {});

      let ids = Object.keys(filtered);

      return ids;
    },
  },

  //********************** */
  methods: {
    activateSubscription: async function () {
      this.activating = true;

      let model = {
        subscriptionId: this.subscriptionDetail.id,
        status: "Active",
        amount: this.subscriptionDetail.amount,
      };

      try {
        await this.$store.dispatch("Subscription/updateSubscription", model);
        await this.loadSubscriptionDetail();
        this.activating = false;
      } catch (error) {
        this.activating = false;
        alert(error);
      }
    },

    cancelSubscription: async function () {
      this.isCanceling = true;

      try {
        await this.$store.dispatch("Subscription/cancelSubscription", this.subscriptionDetail.id );
        await this.$store.dispatch("Subscription/loadCustomerSubscriptions");
        await this.$store.dispatch("Subscription/loadUnpaidInstallments");
        await this.$store.dispatch("Subscription/loadSubscriptionLookup");
        await this.$store.dispatch("Catalog/loadSubscriptionItems");
        
        this.isCanceling = false;
        this.cancelDialog = false;
      } catch (error) {
        this.cancelDialog = false;
        this.isCanceling = false;
        alert(error);
      }
    },
    addMultipleInstallments: async function () {
      let model = {
        subscriptionId: this.subscriptionDetail.id,
        numberOfInstallments: this.quantity,
      };
      this.isAdding = true;
      try {
        await this.$store.dispatch("Subscription/addInstallments", model);
        this.isAdding = false;
        this.addMultipleInstallmentsDialog = false;
        this.quantity = 1;
      } catch (error) {
        this.isAdding = false;
        alert(error);
      }
    },
    completePaymentProcess: async function () {
      /*       let dict = this.unpaidInstallments;
      var filtered = Object.keys(dict).reduce(function (filtered, key) {
        if (dict[key] == true) filtered[key] = dict[key];
        return filtered;
      }, {});
      
      let ids = Object.keys(filtered);
 */

      let model = {
        subscriptionInstallmentIds: this.subscriptionInstallmentIds.map(
          function (item) {
            return parseInt(item, 0);
          }
        ),
      };

      this.isPaying = true;
      try {
        await this.$store.dispatch("Subscription/createInvoice", model);
        this.isPaying = false;
        //console.log(this.externalPaymentUrl);
        window.location = this.externalPaymentUrl.url;
      } catch (error) {
        this.showError = true;

        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }

      this.isPaying = false;
    },

    nextBillingDate: function () {
      return formatDate(this.subscriptionDetail.nextBillingDate);
    },
    toDateString: function (date) {
      if (date) {
        return formatDate(date);
      }

      return "لم يتم الدفع حتى الآن";
    },
    loadSubscriptionDetail: async function () {
      this.isLoading = true;
      await this.$store.dispatch(
        "Subscription/loadSubscriptionDetail",
        this.id
      );

      this.isLoading = false;
      this.prepareUnpaidSubscriptions();
    },

    prepareUnpaidSubscriptions: function () {
      this.unpaidInstallments = this.subscriptionDetail.installments.reduce(
        (a, x) => ({ ...a, [x.id]: false }),
        {}
      );
    },
  },

  //********************** */
  async created() {
    await this.loadSubscriptionDetail();
  },
};
</script>

<style>
</style>